import * as ReselectModule from "reselect";
import { IClientContactPersonListState } from ".";
import { IApplicationState } from "..";

export const selectClientContactPersonList: ReselectModule.Selector<
  IApplicationState,
  IClientContactPersonListState
> = (state) => state.clientContactPersonList;
